import {
    respondToBelow,
    ScreenWidth,
} from '@app/styles/scripts/uiHelpers';

export function isMobile() {
    return respondToBelow(ScreenWidth.dXs);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/layout/isMobile.ts